/**
 * pageTimer — pure visible-time accounting for one page/module visit.
 * Kept side-effect-free so the duration math is unit-testable; the
 * tracker owns the clock and the DOM listeners.
 */
export interface PageTimer {
  moduleId: string | null
  /** Wall-clock ms when visible counting started; null while hidden. */
  sinceMs: number | null
  /** Completed visible time. */
  accruedMs: number
}

export function startPage(moduleId: string | null, now: number, visible: boolean): PageTimer {
  return { moduleId, sinceMs: visible ? now : null, accruedMs: 0 }
}

export function setVisibility(t: PageTimer, visible: boolean, now: number): PageTimer {
  if (visible && t.sinceMs === null) return { ...t, sinceMs: now }
  if (!visible && t.sinceMs !== null) return { ...t, sinceMs: null, accruedMs: t.accruedMs + (now - t.sinceMs) }
  return t
}

/** Close out the page; returns seconds of visible time (rounded), or null if no module. */
export function closePage(t: PageTimer, now: number): { moduleId: string; seconds: number } | null {
  if (!t.moduleId) return null
  const total = t.accruedMs + (t.sinceMs !== null ? now - t.sinceMs : 0)
  return { moduleId: t.moduleId, seconds: Math.round(total / 1000) }
}
